/**
 * Bio component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
// import { StaticQuery, graphql } from "gatsby"
// import { graphql } from "gatsby"
import { makeStyles } from '@material-ui/styles';

import avatar from "src/images/me-1.jpeg";

const useStyles = makeStyles(theme => ({
  writter: {
    ...theme.flex.row,
    ...theme.flex.alignCenter,
  }
}));

export default function Bio(props) {
  
  const classes = useStyles()

  return (
    <div className={classes.writter}
      style={{
        display: `flex`,
      }}
    >
        <span style={{padding: '0 6px', opacity: `0.5`}}>written by</span>
        <img 
          className="user-img"
          src={avatar}
          alt="zuhern1"
          style={{
            marginBottom: 0,
            width: 25,
            height: 25,
            marginRight: 4,
            borderRadius: `50%`,
          }}
        />
        <b>
          <a href={"https://github.com/zuhern"} 
            target="_blank" 
            rel="noopener noreferrer">
            zuhern
          </a>
        </b>
    </div>
  )
}

// export default function Bio(props) {
  
//   const classes = useStyles()

//   return (
//     <StaticQuery
//       query={bioQuery}
//       render={data => {
//         const { author, social } = data.site.siteMetadata
//         return (
//           <div className={classes.writter}
//             style={{
//               display: `flex`,
//             }}
//           >
//             <img 
//               className="user-img"
//               src={avatar}
//               fixed={data.avatar.childImageSharp.fixed}
//               alt={author}
//               style={{
//                 marginBottom: 0,
//                 width: 45,
//                 height: 45,
//                 marginRight: 4,
//                 borderRadius: `50%`,
//               }}
//             />
//             <span>
//               <span style={{padding: '0 6px', opacity: `0.5`,}}>written by</span>
//               <b>
//                 <a href={"https://github.com/" + social.github} 
//                   target="_blank" 
//                   rel="noopener noreferrer">
//                   {author}
//                 </a>
//               </b>
//             </span>
//           </div>
//         )
//       }}
//     />
//   )
// }

// const bioQuery = graphql`
  // query BioQuery {
  //   avatar: file(absolutePath: { regex: "/sweet.jpg/" }) {
  //     childImageSharp {
  //       fixed(width: 50, height: 50) {
  //         ...GatsbyImageSharpFixed
  //       }
  //     }
  //   }
  //   site {
  //     siteMetadata {
  //       author
  //       social {
  //         github
  //       }
  //     }
  //   }
  // }
// `

Bio.propTypes = {
};
